import React from 'react';
import Loading from "@/components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";

const DesktopPayU = dynamic(() => import("../../components/payment-partners/payU/DesktopPayU"), {
    loading: () => <Loading />,
}
);

const MobilePayU = dynamic(() => import("../../components/payment-partners/payU/MobilePayU"), {
    loading: () => <Loading />,
}
);

const payuIntegration = ({ mobileView }) => {
    return (
        <>
            <Head>
                <title>POS Transactions With PayU global payment solutions | QueueBuster</title>
                <meta name="description" content="Payu POS system + QueueBuster POS software = Effortless checkout for your business." />
                <link rel="canonical" href="https://queuebuster.co/pos-payment-partners/payu" />
                <link rel="alternate" href="https://queuebuster.co/pos-payment-partners/payu" hrefLang="en-us" />
                <meta property="og:title" content="POS Transactions With PayU global payment solutions | QueueBuster" />
                <meta property="og:description" content="Payu POS system + QueueBuster POS software = Effortless checkout for your business." />
                <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/payu.jpg" />
                <meta property="og:url" content="https://queuebuster.co/pos-payment-partners/payu" />
                
            </Head>
            {mobileView ? <MobilePayU /> : <DesktopPayU />}
        </>
    )
}

export default payuIntegration